
import { toast } from "react-toastify"
import { fetchConToken } from "../helpers/fetch"

export const initialState = {
    id: 0,
    servicio: '',
    categoria: '',
    id_categoria: 0,
    tipo: 'venta'
}

export const Rules = {

    getValidators: async (ruleId) => {
        try {

            const resp = await fetchConToken(`rules/validator/${ruleId}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    updateStatus: async (data) => {
        try {

            const ruleId = data.rule_id
            const resp = await fetchConToken(`rules/validator/update/${ruleId}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                console.log('--body TETETETE--', body)
                toast.success(body.msg)
                return body.data

            } else {

                toast.error(body.msg)
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

}